import 'font-awesome/css/font-awesome.css'
import Vue from 'vue'

import App from './App'

import './config/bootstrap'
import './config/msgs'
import './config/axios'
import './config/mq'
import './config/mdicon'
import './config/cssAnimate'
import store from './config/store'
import router from './config/router'
import './config/fontAwesome'
import './config/quill_editor'
import './config/vuemask'
import './config/filters'
import './config/perfectScrollbar'
import './config/vueSelect'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')